import { Metamodel } from 'app/model/base/model';
import { FileBasedSettings } from './file-based-settings';
import { ParquetDataset } from 'shell-models-lib';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.parquet.dataflowSettings
})
export class ParquetSettings extends FileBasedSettings {
    public static datasetType = Metamodel.modelFor(ParquetDataset).name;

    public getDatasetType(): string {
        return ParquetSettings.datasetType;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Parquet;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getIconClass(): string {
        return '';
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
    }
}
